import type { Action, Card } from 'src/types';

// @ts-ignore
import { ADD_FAILED_ACTION } from './actionCreators';

type FailedAction = Action & {
  payload: Record<string, unknown>;
};

export type BlendState = Record<string, Record<string, FailedAction>>;

export type BlendAction = Action<typeof ADD_FAILED_ACTION> & {
  payload: {
    parent: Card;
    id: string;
    action: FailedAction;
  };
};

export const reducer = (
  state: BlendState = {},
  action: BlendAction,
): BlendState => {
  switch (action.type) {
    case ADD_FAILED_ACTION: {
      const { parent, id, action: actionName } = action.payload;

      return {
        ...state,
        [parent]: {
          ...state[parent],
          [id]: actionName,
        },
      };
    }

    default: {
      return state;
    }
  }
};
